module.exports = __webpack_public_path__ + "img/TrustServiceCategor8.98dd3dea.png";